import script from "./manage-applicants.vue?vue&type=script&setup=true&lang=js"
export * from "./manage-applicants.vue?vue&type=script&setup=true&lang=js"

import "./manage-applicants.vue?vue&type=style&index=0&id=f48a3312&lang=css"

const __exports__ = script;

export default __exports__